module.exports = __webpack_public_path__ + "static/media/floor-plan.17fac9a9.svg";